import { ResponsiveOptions } from './template-builder-responsive-options';
import { TemplateEditorItems } from './template-builder-item.model';
import { TemplateBuilderContainerProperties } from './template-builder-container-properties';
import { TemplateBuilderCommonColumnsOptions } from './template-builder-common-column-options.model';

export class TemplateBuilderModule {
  type: TemplateEditorItems.module = TemplateEditorItems.module;
  desktopContainerProperties: TemplateBuilderContainerProperties = new TemplateBuilderContainerProperties();
  mobileContainerProperties?: Partial<TemplateBuilderContainerProperties> = {};
  responsiveOptions: ResponsiveOptions = new ResponsiveOptions();
  desktopColumnOptions: TemplateBuilderCommonColumnsOptions = new TemplateBuilderCommonColumnsOptions();
  mobileColumnOptions: Partial<TemplateBuilderCommonColumnsOptions> = {};

  constructor(public templateDbId: string) {}
}
